export default {
    meEndpoint: '/api/v1/auth/refreshToken',
    loginEndpoint: '/api/admin/login',
    registerEndpoint: '/api/admin/registration',
    storageTokenKeyName: 'adminAccessToken',
    selectedJeweller : 'selectedJeweller',
    onTokenExpiration: 'adminRefreshToken' // logout | refreshToken
  }
  